// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_f4-0";
export var fulfillmentPanelBody = "_f4-1";